import { gql } from '@apollo/client'

export const Query = gql`
  query Events(
    $companyId: ID!,
    $filters: EventFilters,
    $order: EventOrder,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    events(
      companyId: $companyId,
      filters: $filters,
      order: $order,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        description
        client { id organisationName }
        organisers { id avatar { url } }
        dateOut
        dateReturn
        categories { id name color }
        state
        totalCents
        currency
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
